import React from 'react';

const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
let d = new Date();
let curr_date = d.getDate();
let curr_month = d.getMonth(); //Months are zero based
let curr_year = d.getFullYear();
export const FormatttedDate = locale =>
  curr_date.toLocaleString(locale, { minimumIntegerDigits: 2 }) +
  ' ' +
  monthNames[curr_month] +
  ', ' +
  curr_year;

// YEAR & MONTH options for the select dropdowns
let yearsArray = [];
let monthsArray = [];
let limitYear = curr_year - 118;
let limitMonth = 12;
for (let i = curr_year; i >= limitYear; i--) {
  yearsArray.push(i);
}
for (let i = 1; i <= limitMonth; i++) {
  monthsArray.push(i);
}

export const YearOptions = yearsArray.map((eachValue, i) => (
  <option value={eachValue} key={i}>
    {eachValue}
  </option>
));

export const MonthOptions = monthsArray.map((eachValue, i) => (
  <option value={eachValue} key={i}>
    {eachValue}
  </option>
));

export const dateW3CFormatter = date => {
  let tempDate = new Date(date);
  let year = tempDate.getFullYear();
  let month = tempDate.getMonth();
  let day = tempDate.getDate();
  let hours = tempDate.getHours();
  let minutes = tempDate.getMinutes();
  let seconds = tempDate.getSeconds();

  month = month < 10 ? `0${month + 1}` : month + 1;
  day = day < 10 ? `0${day}` : day;
  hours = hours < 10 ? `0${hours}` : hours;
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  let offset = -tempDate.getTimezoneOffset();
  let offsetHours = Math.abs(Math.floor(offset / 60));
  let offsetMinutes = Math.abs(offset) - offsetHours * 60;

  offsetHours = offsetHours < 10 ? `0${offsetHours}` : offsetHours;
  offsetMinutes = offsetMinutes < 10 ? `0${offsetMinutes}` : offsetMinutes;
  let offsetSign = offset < 0 ? '-' : '+';

  let _date = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  let _offset = `${offsetSign}${offsetHours}:${offsetMinutes}`;

  return `${_date}${_offset}`;
};
